import React, { useState } from "react";
import "./Header.css";
import { IoMdArrowDropdown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { persistor } from "../../../AsianExchangeSrc/redux/store";
import { revertUser } from "../../../AsianExchangeSrc/redux/slices/userSlice";
import { revertAccount } from "../../../AsianExchangeSrc/redux/slices/accountSlice";

const Header = () => {
  const userData = useSelector((state) => state?.user?.userData) || {};
  const exposure = Number(userData?.exposure || 0);
  const availableBalance = Number(userData.availableBalance - exposure || 0);
  const dispatch = useDispatch();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleLogout = async (event) => {
    event.preventDefault();
    dispatch(revertUser());
    localStorage.clear();

    await persistor.purge();
  };

  return (
    <>
      <div className="w-full h-[70px] bg-[#0088CC] text-white flex justify-between items-center px-3">
        <div className="flex justify-between items-center w-full">
          <Link to="/">
            <img
              src="/logo.png"
              alt="igambli"
              className="md:h-[80px] h-[60px]"
            />
          </Link>

          <div className="flex flex-col sm:flex-row items-end sm:items-center sm:gap-4 text-[14px] leading-[17px] text-white relative">
            <li className="list-none">
              Balance:{" "}
              <span className="text-green-400">{availableBalance}</span>
            </li>
            <li className="list-none">
              Exp: <span className="text-yellow-300">{exposure}</span>
            </li>

            <li
              className="list-none flex items-center gap-1 text-[14px] cursor-pointer relative"
              onClick={toggleDropdown}
            >
              <span>{userData.userName}</span>
              <IoMdArrowDropdown className="text-xl" />

              {/* Dropdown */}
              {isDropdownOpen && (
                <ul className="absolute top-[100%] right-0 mt-1 w-[160px] bg-white text-black rounded shadow-md z-50 p-2">
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Account Statement</Link>
                  </li>
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Profit Loss Report</Link>
                  </li>
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Bet History</Link>
                  </li>
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Unsettled Bet</Link>
                  </li>
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Set Button Values</Link>
                  </li>
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Change Password</Link>
                  </li>
                  <li className="px-3 py-1.5 hover:bg-gray-100 text-[13.5px]">
                    <Link to="/#">Rules</Link>
                  </li>
                  <li
                    className="px-3 py-1 hover:bg-red-100 text-sm text-red-600 font-semibold"
                    onClick={handleLogout}
                  >
                    SignOut
                  </li>
                </ul>
              )}
            </li>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
